import * as React from "react";
import { PaymentInstructionLayout } from "../../../../../../../../component/modules/PaymentMethodsList/component/PaymentInstructionLayout.js";
const KlarnaPayNow = () => {
  return /* @__PURE__ */ React.createElement(PaymentInstructionLayout, { info: "checkout.payment.method.klarna_pay_now.info" });
};
export {
  KlarnaPayNow
};
//# sourceMappingURL=KlarnaPayNow.js.map
